import MComponent from '../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../Toolkit/WithRouterProps';
import WithRouter from '../Toolkit/WithRouter';
import React, {createRef, ReactElement, RefObject} from 'react';
import {CreateNoticeValidator, EditNoticeValidator, Notice, NoticeDetail, NoticeHeader, NoticeReply} from '../Api/NoticeTypes';
import * as Yup from 'yup';
import MPage, {MPageProps} from '../Toolkit/Components/Shell/Page';
import MToolbar from '../Toolkit/Components/Controls/Toolbar';
import MButton from '../Toolkit/Components/Controls/Button';
import {MCloseIconName, MSaveIconName} from '../Toolkit/Icons';
import MSpacer from '../Toolkit/Components/Controls/Spacer';
import EnumContext from '../Context/enum-context';
import MForm, {MFormOutcome} from '../Toolkit/Components/Controls/Form';
import {FieldProps, FormikHelpers} from 'formik';
import {MNullable, toErrorMessage} from '../Toolkit/Utils';
import FormSection from '../Toolkit/Components/Controls/FormSection';
import MFormFieldControl from '../Toolkit/Components/Controls/FormFieldControl';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MNumericBox from './Components/NumericBox';
import MDropDownMulti from './Components/DropDownMulti';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import TextArea from './Components/TextArea';
import MCalendar from '../Toolkit/Components/Controls/Calendar';
import {MDropDownItem} from '../Toolkit/Components/Controls/DropDownOption';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import {NoticeClient, NoticeUpdateDto} from '../Api/NoticeClients';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../Api/SafeDigAccessTokenProvider';
import {Roles} from '../Roles';
import {EnumerationClient} from '../Api/EnumerationClients';
import {Enumeration, NoticeStatusReply} from '../Api/EnumerationTypes';
import {Divider} from 'primereact/divider';
import MFormSection from '../Toolkit/Components/Controls/FormSection';
import NoteListControl from './Components/NoteListControl';
import {Note} from '../Api/NoteTypes';
import {NoteCreateDto, SafeDigClient, SafeDigSendRequest} from '../Api/SafeDigsClients';
import MFormControl from '../Toolkit/Components/Controls/FormControl';
import StatusControl from './Components/StatusControl';
import {ChangeFileStateRequest, CreateSafeDigFileRequest, SafeDigFileClient} from '../Api/SafeDigFilesClients';
import {CreateSafeDigFileReply, SafeDigFile, SafeDigFileListReply, UpdateSafeDigFileReply} from '../Api/SafeDigFileTypes';
import FileListControl from './Components/FileListControl';
import NoticeFileDialog, {NoticeUploadData} from './Dialogs/NoticeFileDialog';
import FileStatusDialog, {FileStatusResult} from './Dialogs/FileStatusDialog';
import {ProjectReply, UpdateSafeDigReply} from '../Api/SafeDigTypes';
import AuditListControl from './Components/AuditListControl';
import {AuditLog, AuditLogListReply} from '../Api/AuditTypes';
import {AuditLogClient} from '../Api/AuditLogClients';
import RegistrationListControl, { RegistrationRow } from './Components/RegistrationListControl';
import {RegistrationMultiReply, Registration} from '../Api/RegistrationTypes';
import {RegistrationClient} from '../Api/RegistrationClients';
import {GotoIconName} from './SafeDigConstants';
import JobSendDialog from './Dialogs/JobSendDialog';
import {ContactClient} from '../Api/ContactClients';
import {ContactReply} from '../Api/ContactTypes';

type RouteParams = {
    id: string;
};

type Props =  WithMsalProps & WithRouterProps<RouteParams> & {};

type NoteRow = {
    data: Note;
}

type FileData = {
    permitState: number;
    permitStart: MNullable<Date>;
    permitEnd: MNullable<Date>;
    tmPlanState: number;
    tmPlanStart: MNullable<Date>;
    tmPlanEnd: MNullable<Date>;
}

type SafeDigFileRow = {
    data: SafeDigFile;
}

type AuditLogRow = {
    data: AuditLog;
}

type State = {
    page: MPageProps;
    pageTitle: string;
    pageSubTitle: string;
    form: {
        id: string;
        isSubmitting: boolean;
        notice: Notice;
        fileData: FileData;
        miscFiles: SafeDigFileRow[];
        notes: NoteRow[];
        registrations: RegistrationRow[];
        audit: AuditLogRow[];
        validationSchema: any;
        noticeStates: Enumeration[];
    };
    projectList: MDropDownItem<number>[];
};

class EditNoticeDetailPage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_fileUploadRef: RefObject<NoticeFileDialog>;
    private readonly m_fileStatusRef: RefObject<FileStatusDialog>;
    private readonly m_noticeClient: NSwagAdapter<NoticeClient>;
    private readonly m_fileClient: NSwagAdapter<SafeDigFileClient>;
    private readonly m_enumerationClient: NSwagAdapter<EnumerationClient>;
    private readonly m_safedigClient: NSwagAdapter<SafeDigClient>;
    private readonly m_registrationClient: NSwagAdapter<RegistrationClient>;
    private readonly m_auditlogClient: NSwagAdapter<AuditLogClient>;
    private readonly m_contactClient: NSwagAdapter<ContactClient>;
    private readonly m_jobSendRef: RefObject<JobSendDialog>;

    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_pageRef = createRef<MPage>();
        this.m_fileUploadRef = createRef<NoticeFileDialog>();
        this.m_fileStatusRef = createRef<FileStatusDialog>();
        this.m_jobSendRef = createRef<JobSendDialog>();
        this.m_noticeClient = new NSwagAdapter<NoticeClient>(new NoticeClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_fileClient = new NSwagAdapter<SafeDigFileClient>(new SafeDigFileClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_enumerationClient = new NSwagAdapter<EnumerationClient>(new EnumerationClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_safedigClient = new NSwagAdapter<SafeDigClient>(new SafeDigClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_registrationClient = new NSwagAdapter<RegistrationClient>(new RegistrationClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_auditlogClient = new NSwagAdapter<AuditLogClient>(new AuditLogClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_contactClient = new NSwagAdapter<ContactClient>(new ContactClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));

        this.initializeState();

    }

    private bindMethods(): void {
        this.close_Click = this.close_Click.bind(this);
        this.send_Click = this.send_Click.bind(this);
        this.toSafeDig_Click = this.toSafeDig_Click.bind(this);
        this.onNewNote = this.onNewNote.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.form_onBeforeSubmit = this.form_onBeforeSubmit.bind(this);
        this.form_onSubmit = this.form_onSubmit.bind(this);
        this.form_onAfterSubmit = this.form_onAfterSubmit.bind(this);
        this.form_onError = this.form_onError.bind(this);
        this.isFormDisabled = this.isFormDisabled.bind(this);
        this.isNoticingTeamMember = this.isNoticingTeamMember.bind(this);
        this.isEditDisabled = this.isEditDisabled.bind(this);
        this.isPermitUpdateDisabled = this.isPermitUpdateDisabled.bind(this);
        this.isComplete = this.isComplete.bind(this);
        this.onFileUploadClicked = this.onFileUploadClicked.bind(this);
        this.uploadCallback = this.uploadCallback.bind(this);
        this.ChangeFileIncludeStatus = this.ChangeFileIncludeStatus.bind(this);
        this.onFileListRefresh = this.onFileListRefresh.bind(this);
        this.onFileUploadClicked = this.onFileUploadClicked.bind(this);
        this.fileStatusDialog_Close = this.fileStatusDialog_Close.bind(this);
        this.goto_Click = this.goto_Click.bind(this);
        this.jobSendDialog_onClose = this.jobSendDialog_onClose.bind(this);
    }

    private initializeState(): void {
        const page: MPageProps = {locked: false};

        const data: Notice = {
            header: {
                id: 0,
                odinId: '',
                safeDigId: -1,
                parentId: -1,
                requestedDate: new Date(),
                l2Id: undefined,
                project: -1
            },
            detail: {
                id: 0,
                headerId: -1,
                requestedDate: new Date(),
                address1: '',
                address2: '',
                address3: '',
                county: '',
                northing: 0,
                easting: 0,
                northing2: 0,
                easting2: 0,
                worksLocations: [],
                workDescription: '',
                requestor: '',
                startDate: null,
                endDate: null,
                tmType: [],
                fwClosureType: -1,
                trafficSensitiveHours: -1,
                hoursOfWork: '',
                excavationRequired: true,
                phaseType: 0,
                cancelReason: -1,
                cancelNote: '',
                permitNumber: '',
                permitStatus: 0,
                submissionDate: null,
                noticeStatus: 0,
                usrn: undefined,
                permitType: -1,
                roadType: -1,
                project: -1,
                subResource: -1
            },
            permitFileState: 0,
            tmFileState: 0
        };

        const validationSchema: any = Yup.object().shape({
            detail: Yup.object().shape({
                address1: EditNoticeValidator.address1,
                address2: EditNoticeValidator.address2,
                address3: EditNoticeValidator.address3,
                northing: EditNoticeValidator.northing,
                easting: EditNoticeValidator.easting,
                northing2: EditNoticeValidator.northing2,
                easting2: EditNoticeValidator.easting2,
                worksLocations: EditNoticeValidator.worksLocations,
                workDescription: EditNoticeValidator.workDescription,
                requestor: EditNoticeValidator.requestor,
                cancelReason: EditNoticeValidator.cancelReason,
                cancelNote: EditNoticeValidator.cancelNote,
                startDate: EditNoticeValidator.startDate,
                endDate: EditNoticeValidator.endDate,
                tmType: EditNoticeValidator.tmType,
                fwClosureType: EditNoticeValidator.fwClosureType,
                trafficSensitiveHours: CreateNoticeValidator.trafficSensitiveHours,
                permitNumber: EditNoticeValidator.permitNumber,
                hoursOfWork: EditNoticeValidator.hoursOfWork,
                usrn: EditNoticeValidator.usrn,
                permitType: EditNoticeValidator.permitType,
                project: EditNoticeValidator.project
            }),
        });

        const fileData: FileData = {
            permitState: 0,
            permitStart: null,
            permitEnd: null,
            tmPlanState: 0,
            tmPlanStart: null,
            tmPlanEnd: null
        }

        this.state = {
            page: page,
            pageTitle: 'Edit Notice Detail',
            pageSubTitle: '',
            form: {
                isSubmitting: false,
                id: 'EditNoticeForm',
                notice: data,
                audit: [],
                fileData: fileData,
                miscFiles: [],
                notes: [],
                registrations: [],
                validationSchema: validationSchema,
                noticeStates: [],
            },
            projectList: []
        };
    }

    public componentDidMount(): void {
    }

    private isFormDisabled(): boolean {
        return this.state.form.isSubmitting;
    }

    private isNoticingTeamMember(): boolean {
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        return roles?.includes(Roles.Noticing) ?? false;
    }

    private isEditDisabled(): boolean {
        const disabledPermitStatuses = [ 0, 5, 7 ];

        //data can only be edited by noticing team members or if the status is 1 (More info required)
        return (!this.isNoticingTeamMember() && disabledPermitStatuses.includes(this.state.form.notice.detail!.permitStatus))
            || this.isFormDisabled();
    }

    private isPermitUpdateDisabled(): boolean {
        return !this.isNoticingTeamMember() || this.isFormDisabled();
    }

    private isComplete(): boolean{
        return this.state.form.notice.detail!.noticeStatus === 4;
    }

    /** */
    private async close_Click(): Promise<void> {
        this.props.history.goBack();
    }

    private async goto_Click(): Promise<void> {
        const noticeId = this.state.form.notice.header!.parentId;
        this.props.navigate(`/notices/${noticeId}`);
        window.location.reload();
    }

    private async send_Click() : Promise<void> {
        let preFill: string[] = [];
        if(this.state.form.notice.detail!.subResource !== null && this.state.form.notice.detail!.subResource !== undefined && this.state.form.notice.detail!.subResource !== -1)
        {
            const contactResult = await this.m_contactClient.callWithReply(
                ContactReply,
                (client) => client.contactData(this.state.form.notice.detail!.subResource)
            )
            contactResult.throwIfFailed();
            preFill = [contactResult.reply?.contact?.contactEmail ?? ""];
        }

        this.m_jobSendRef.current!.show(this.state.form.notice.header!.odinId, preFill);
    }

    private toSafeDig_Click(): void {
        this.props.navigate(`/safedigs/${this.state.form.notice.header!.safeDigId}`);
    }

    private async jobSendDialog_onClose(emailAddresses: string[]) {
        const userName = this.props.msalContext.accounts[0].name;

        const sendResult = await this.m_noticeClient.callWithReply(
            UpdateSafeDigReply,
            (client) => client.sendFiles(new SafeDigSendRequest({
                safeDigId: this.state.form.notice.detail!.id,
                emailAddresses: emailAddresses,
                user: userName
            })));

        sendResult.throwIfFailed();

        await this.page_onLoadData();
    }

    private async onNewNote(data: string) {
        const userName = this.props.msalContext.accounts[0].name;

        await this.m_noticeClient.call((client) => client.addNote(new NoteCreateDto({
            safeDigsId: this.state.form.notice.detail!.id,
            noteText: data,
            user: userName
        })));

        await this.page_onLoadData();
    }

    private async onFileUploadClicked(fileType: number){
        let validFile = false;

        switch(fileType){
            case 11:
                validFile = this.state.form.fileData.permitState === 2;
                break;
            case 12:
                validFile = this.state.form.fileData.tmPlanState === 2;
                break;
        }

        if(validFile){
            const fileData = await this.m_fileClient.callWithReply(
                SafeDigFileListReply,
                (client) => client.get(this.state!.form!.notice.detail!.id, fileType, 1));
            this.m_fileStatusRef.current!.show({
                    estimate: this.state.form.notice.detail!.id.toString(),
                    fileType: fileType,
                    fileInfo: fileData.reply!.data[0].fileInfo,
                    expiryDate: fileData.reply!.data[0].expiryDate
                },
                true, 1);
        } else {
            this.m_fileUploadRef.current!.show(this.uploadCallback, fileType);
        }

    }

    private async uploadCallback(data: NoticeUploadData){
        const userName = this.props.msalContext.accounts[0].name;

        const createRequest = new CreateSafeDigFileRequest({
            safeDigsId: this.state.form.notice.detail!.id,
            fileType: data.fileType,
            appArea: 1,
            lineSearchPositive: false,
            startDate: data.startDate,
            expiryDate: data.expiryDate,
            file: data.file!,
            fileInfo: 'Noticing file',
            fileName: data.fileName,
            user: userName
        });

        const result = await this.m_fileClient.callWithReply(CreateSafeDigFileReply, (client) => client.post(createRequest));
        result.throwIfFailed();

        //Refresh page before closing dialog.
        this.page_onLoadData();
        this.m_fileUploadRef.current!.hide();
    }


    private async ChangeFileIncludeStatus(safeDigFileId: number, newValue: boolean) {
        await this.m_fileClient.callWithReply(UpdateSafeDigFileReply, (client) => client.changeFileIncludeState(safeDigFileId, newValue));
        this.ReadFileData(this.state.form.notice.detail!.id, this.state.form.notice.header!.safeDigId);
    }

    private onFileListRefresh() {
        this.ReadFileData(this.state.form.notice.detail!.id, this.state.form.notice.header!.safeDigId);
    }

    private async fileStatusDialog_Close(fileType: number, result: FileStatusResult) {
        const userName = this.props.msalContext.accounts[0].name;

        if(result === FileStatusResult.Archive) {
            const changeRequest = new ChangeFileStateRequest({
                safeDigsId: this.state.form.notice.detail!.id,
                fileType: fileType,
                fileArea: 1,
                oldStatus: 2,
                newStatus: 3,
                user: userName
            });

            const result = await this.m_fileClient.callWithReply(
                UpdateSafeDigFileReply,
                (client) => client.changeFileState(changeRequest));

            result.throwIfFailed();

            await this.page_onLoadData();
        } else if(result === FileStatusResult.Download) {
            const result = await this.m_fileClient.callWithReply(
                UpdateSafeDigFileReply,
                (client) => client.download(this.state.form.notice.detail!.id, fileType,1));

            result.throwIfFailed();
        }
    }

    private phaseTypeChange(fieldProps: FieldProps, newValue: MNullable<number>): void {
        //If the phase type is changed to Cancelled then reset the Permit Status to Requested
        const oldValue = fieldProps.form.values.phaseType;

        if(newValue !== null && newValue === 3) {
            fieldProps.form.setFieldValue('permitStatus', 4);
        } else if(oldValue === 3){ //The previous value was 'Cancelled' so restore the original value for permit status
            fieldProps.form.setFieldValue('permitStatus', this.state.form.notice.detail!.permitStatus);
        }
    }

    private async page_onLoadData(): Promise<void> {
        const id = Number(this.props.match.params.id);

        //Pull notice data
        const result = await this.m_noticeClient.callWithReply(
            NoticeReply, (client) => client.notice(id));
        result.throwIfFailed();

        //Read Registration data
        const regResult = await this.m_registrationClient.callWithReply(
            RegistrationMultiReply, (client) => client.listRegistrations(id))
        regResult.throwIfFailed();

        //Read audit data
        const auditResult = await this.m_auditlogClient.callWithReply(
            AuditLogListReply, (client) => client.getDigAudit(id, 1));
        auditResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.form.registrations = regResult.reply!.registrations!.map((r: Registration) => {
               return {data: r} as RegistrationRow;
            });
            draft.form.audit = auditResult.reply!.data!.map((w: AuditLog) => {
                return {data: w} as AuditLogRow;
            });
        });

        //Get the current states available
        const noticeResult = await this.m_enumerationClient.callWithReply(
            NoticeStatusReply, (client) => client.getNoticeStatuses(result.reply?.detail?.noticeStatus));
        noticeResult.throwIfFailed();

        //Read Project list
        const projectResult = await this.m_safedigClient.callWithReply(
            ProjectReply, (client) => client.getProjects());
        projectResult.throwIfFailed();

        const listRows = projectResult.reply!.data.map(project => ({
            value: project.id,
            label: project.name
        }));
        
        if(result.reply!.header !== null) {
            this.safeSetState(draft => {
                draft.form.notice = result.reply!;
                draft.form.noticeStates = noticeResult.reply!.noticeStatuses;
                draft.form.notes = result.reply!.notes.map(n => { return {data: n}});
                draft.projectList = listRows;
            });

            await this.ReadFileData(result.reply!.detail!.id, result.reply!.header!.safeDigId);
        }
    }

    private async ReadFileData(noticeId: number, safeDigId: number){
        const permitFileResult = await this.m_fileClient.callWithReply(SafeDigFileListReply,
            (client) => client.get(noticeId, 11, 1));
        permitFileResult.throwIfFailed();

        const tmFileResult = await this.m_fileClient.callWithReply(SafeDigFileListReply,
            (client) => client.get(noticeId, 12, 1));
        tmFileResult.throwIfFailed();

        //Read file data
        const fileResult = await this.m_fileClient.callWithReply(SafeDigFileListReply,
            (client) => client.getMisc(noticeId, 1));
        fileResult.throwIfFailed();

        //Read Jobpack
        const jobPackResult = await this.m_fileClient.callWithReply(SafeDigFileListReply,
                     (client) => client.listDocumentByType(safeDigId, 'Job Pack',0));
                 fileResult.throwIfFailed();


        const expiryDate = new Date();
        expiryDate.setHours(0, 0, 0, 0);
        const permitFile = permitFileResult.reply!.data;
        const tmFile = tmFileResult.reply!.data;
        const fileData: FileData = {
            permitState: permitFile.length > 0 ? permitFile[0].fileStatus : 0,
            permitStart: permitFile.length > 0 ? permitFile[0].startDate: null,
            permitEnd: permitFile.length > 0 ? permitFile[0].expiryDate: null,
            tmPlanState: tmFile.length > 0 ? tmFile[0].fileStatus : 0,
            tmPlanStart: tmFile.length > 0 ? tmFile[0].startDate: null,
            tmPlanEnd: tmFile.length > 0 ? tmFile[0].expiryDate: null,
        }
        const miscFiles = fileResult.reply!.data.filter(f => (f.fileType !== 11 && f.fileType !== 12) || f.fileStatus === 3);
        if(jobPackResult.reply!.data.length > 0)
            miscFiles.push(jobPackResult.reply!.data[0])

        this.safeSetState(draft => {
            draft.form.fileData = fileData;
            draft.form.miscFiles = miscFiles.map(f => {return {data: f}});
        });
    }

    private form_onBeforeSubmit(fieldValues: Notice, formikHelpers: FormikHelpers<Notice>): boolean {
        this.safeSetState(draft => draft.form.isSubmitting = true);
        return false;
    }

    private async form_onSubmit(fieldValues: Notice, formikHelpers: FormikHelpers<Notice>): Promise<void> {
        const updateData = new NoticeUpdateDto({
            id: fieldValues.detail!.id,
            odinId: fieldValues.header!.odinId,
            safeDigId: fieldValues.header!.safeDigId,
            parentId: fieldValues.header!.parentId,
            address1: fieldValues.detail!.address1,
            address2: fieldValues.detail!.address2,
            address3: fieldValues.detail!.address3,
            county: fieldValues.detail!.county,
            easting: fieldValues.detail!.easting,
            northing: fieldValues.detail!.northing,
            easting2: fieldValues.detail!.easting2 === undefined || fieldValues.detail!.easting2 === null ? 0 : fieldValues.detail!.easting2,
            northing2: fieldValues.detail!.northing2 === undefined || fieldValues.detail!.northing2 === null ? 0 : fieldValues.detail!.northing2,
            worksLocations: fieldValues.detail!.worksLocations,
            workDescription: fieldValues.detail!.workDescription,
            requestor: fieldValues.detail!.requestor,
            phaseType: fieldValues.detail!.phaseType,
            //If the phase type is not cancelled then clear cancel reason and note.
            cancelReason: fieldValues.detail!.phaseType === 3 ? fieldValues.detail!.cancelReason : -1,
            cancelNote: fieldValues.detail!.phaseType === 3 ? fieldValues.detail!.cancelNote : '',
            startDate: fieldValues.detail!.startDate!,
            endDate: fieldValues.detail!.endDate!,
            tmType: fieldValues.detail!.tmType,
            fwClosureType: fieldValues.detail!.fwClosureType,
            permitNumber: fieldValues.detail!.permitNumber,
            submissionDate: fieldValues.detail!.submissionDate,
            permitStatus: fieldValues.detail!.permitStatus,
            trafficSensitiveHours: fieldValues.detail!.trafficSensitiveHours,
            hoursOfWork: fieldValues.detail!.hoursOfWork,
            excavationRequired: fieldValues.detail!.excavationRequired,
            noticeStatus: fieldValues.detail!.noticeStatus,
            usrn: fieldValues.detail!.usrn,
            permitType: fieldValues.detail!.permitType,
            l2id: fieldValues.header!.l2Id,
            project: fieldValues.detail!.project,
            roadType: fieldValues.detail!.roadType,
            subResource: fieldValues.detail!.subResource
        });

        const result = await this.m_noticeClient.callWithReply(NoticeReply, (client => client.update(updateData)));

        result.throwIfFailed()
    }

    private async form_onAfterSubmit(outcome: MFormOutcome, fieldValues: Notice, formikHelpers: FormikHelpers<Notice>, exception: any | undefined): Promise<void> {
        if(outcome === 'success') {
            this.m_pageRef.current!.messageBar.success(`Save complete.`);
        }
        this.safeSetState(draft => draft.form.isSubmitting = false);

        await this.page_onLoadData();
    }

    private form_onError(exception: any): boolean
    {
        const handled = false;
        this.m_pageRef.current!.messageBar.error(toErrorMessage(exception));
        return handled;
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {
        return (
            <MToolbar>
                <MButton label="Save"
                         formId={this.state.form.id}
                         type="submit"
                         color="success"
                         icon={MSaveIconName}
                         iconOnly={false}
                         isBusy={this.isFormDisabled}
                         disabled={this.isFormDisabled}/>
                <MSpacer/>
                <MButton label="Close"
                         icon={MCloseIconName}
                         disabled={this.isFormDisabled}
                         onClick={this.close_Click}/>
                <MSpacer/>
                {(this.state.form.notice.header!.parentId !== -1) && <React.Fragment>
                    <MButton label="Parent"
                             icon={GotoIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.goto_Click}/>
                    <MSpacer/>
                </React.Fragment>}
                {this.state.form.notice.header!.safeDigId > -1 &&
                    <React.Fragment>
                        <MButton label="Safe Dig"
                                 icon={GotoIconName}
                                 disabled={false}
                                 onClick={this.toSafeDig_Click}
                        />
                    </React.Fragment>}
            </MToolbar>
        );

    }

    public render(): ReactElement {

        const id = Number(this.props.match.params.id);
        const yesNoList: MDropDownItem<boolean>[] = [{label: 'No', value: false},{label: 'Yes', value: true}];
        const userName = this.props.msalContext.accounts[0].name;
        const roles = this.props.msalContext.accounts[0].idTokenClaims!.roles;
        const hasNoticingRole = roles?.includes(Roles.Noticing) ?? false;
        const tmPlanRequiredStates = [0,1,2,3,4,5,6,7];

        return (
          <MPage title={this.state.pageTitle}
                 subtitle={this.state.pageSubTitle}
                 locked={this.state.page.locked}
                 width={8}
                 toolbar={this.getToolbarTemplate()}
                 onLoadData={this.page_onLoadData}
                 ref={this.m_pageRef}>

              <MForm formId={this.state.form.id}
                     initialValues={this.state.form.notice}
                     validationSchema={this.state.form.validationSchema}
                     onBeforeSubmit={this.form_onBeforeSubmit}
                     onSubmit={this.form_onSubmit}
                     onAfterSubmit={this.form_onAfterSubmit}
                     onError={this.form_onError}>

                  <NoticeFileDialog ref={this.m_fileUploadRef}
                                    jobComplete={false}
                                    uploadPermission={hasNoticingRole}
                  />
                  <FileStatusDialog ref={this.m_fileStatusRef}
                                    onDialogClose={this.fileStatusDialog_Close}
                                    jobComplete={false}
                  />
                  <JobSendDialog ref={this.m_jobSendRef} onDialogClose={this.jobSendDialog_onClose}/>

                  <div className="formgrid grid">
                      <div className="col-12">

                          <FormSection title="General">
                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="ID"
                                                     fieldName="header.odinId">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.OdinIdMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={true}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Permit Type'}
                                                     fieldName={'detail.permitType'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={false}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.permitTypes.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Project'}
                                                     fieldName={'header.project'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={true}
                                                                 fieldProps={fieldProps}
                                                                 items={this.state.projectList}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="L2 ID"
                                                     fieldName="header.l2Id">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.L2IdMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={true}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Date Requested"
                                                     fieldName="header.requestedDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={true}
                                                         className={fieldClasses}
                                                         initialValue={fieldProps.field.value}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Requested By"
                                                     fieldName="header.requestor">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.RequestorMaxLength}
                                                        readonly={false}
                                                        fieldProps={fieldProps}
                                                        disabled={true}
                                                        className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Status'}
                                                     fieldName={'detail.noticeStatus'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={this.isEditDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.state.form.noticeStates.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Works Locations"
                                                     fieldName="detail.worksLocations">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MDropDownMulti<number> id={fieldProps.field.name}
                                                                      disabled={this.isEditDisabled}
                                                                      fieldProps={fieldProps}
                                                                      items={this.context?.enums === null ? [] : this.context?.enums.worksLocationTypes.map((enumvalue) => {
                                                                          return {label: enumvalue.name, value: enumvalue.id};
                                                                      })}
                                                                      initialValue={[]}
                                                                      maxSelectedLabels={5}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Proposed Start Date"
                                                     fieldName="detail.startDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={this.isEditDisabled}
                                                         className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Proposed End Date"
                                                     fieldName="detail.endDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={this.isEditDisabled}
                                                         className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="TM Types"
                                                     fieldName="detail.tmType">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MDropDownMulti<number> id={fieldProps.field.name}
                                                                      disabled={this.isFormDisabled}
                                                                      fieldProps={fieldProps}
                                                                      items={this.context?.enums === null ? [] : this.context?.enums.tmTypes.map((enumvalue) => {
                                                                          return {label: enumvalue.name, value: enumvalue.id};
                                                                      })}
                                                                      initialValue={[]}
                                                                      maxSelectedLabels={13}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'FW Closure'}
                                                     fieldName={'detail.fwClosureType'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={this.isEditDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.fwClosures.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Traffic Sensitive Hours'}
                                                     fieldName={'detail.trafficSensitiveHours'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                  disabled={this.isEditDisabled}
                                                                  fieldProps={fieldProps}
                                                                  items={this.context?.enums === null ? [] : this.context?.enums.sensitiveHours.map((enumvalue) => {
                                                                      return {label: enumvalue.name, value: enumvalue.id};
                                                                  })}
                                                                  initialValue={-1}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Hours of Work"
                                                     fieldName="detail.hoursOfWork">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeDetail.HoursOfWorkMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Excavation Required'}
                                                     fieldName={'detail.excavationRequired'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<boolean> id={fieldProps.field.name}
                                                                  disabled={this.isEditDisabled}
                                                                  fieldProps={fieldProps}
                                                                  items={yesNoList}
                                                                  initialValue={false}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-12">
                                  <MFormFieldControl label="Work Description"
                                                     fieldName="detail.workDescription">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <TextArea id={fieldProps.field.name}
                                                        maxLength={500}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isEditDisabled}
                                                        className={fieldClasses}
                                                        rows={5}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                          </FormSection>

                          <Divider/>

                          <MFormSection title="Notes">
                              <div className="min-w-full">
                                  <NoteListControl rowData={this.state.form.notes ?? []}
                                                   saveNote={this.onNewNote}
                                                   jobComplete={this.isComplete()}
                                  />
                              </div>
                          </MFormSection>

                          <Divider/>

                          <FormSection title="Permit Status">
                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Permit Number"
                                                     fieldName="detail.permitNumber">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeDetail.PermitNumberMaxLength}
                                                        readonly={false}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isPermitUpdateDisabled}
                                                        className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="USRN"
                                                     fieldName="detail.usrn">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeDetail.UsrnMaxLength}
                                                        readonly={false}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Road Type'}
                                                     fieldName={'detail.roadType'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={this.isFormDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.roadTypes.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Phase Type'}
                                                     fieldName={'detail.phaseType'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={this.isFormDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.phaseTypes.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                                                 onChange={e => this.phaseTypeChange(fieldProps, e)}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Permit Status'}
                                                     fieldName={'detail.permitStatus'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={this.isFormDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.permitStates.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Date Submitted"
                                                     fieldName="detail.submissionDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={this.isPermitUpdateDisabled}
                                                         className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Cancellation Reason'}
                                                     fieldName={'detail.cancelReason'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={fieldProps.form.values.phaseType !== 3}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.cancelReasons.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                                                 onChange={e => this.phaseTypeChange(fieldProps, e)}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-8">
                                  <MFormFieldControl label="Cancellation Comment"
                                                     fieldName="detail.cancelNote">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeDetail.CancelNoteMaxLength}
                                                        readonly={false}
                                                        fieldProps={fieldProps}
                                                        disabled={fieldProps.form.values.phaseType !== 3}
                                                        className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Sub Resource'}
                                                     fieldName={'detail.subResource'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={this.isFormDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.subResources.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>
                          </FormSection>

                          <Divider/>

                          <FormSection title="Files">
                              <div className="col-12 md:col-2">
                                  <MFormControl label={''} id="detail.permitStatus">
                                      {() => {
                                          return (
                                              <StatusControl size={40}
                                                             initialValue={this.state.form.fileData.permitState}
                                                             onClick={this.onFileUploadClicked.bind(this, 11)}
                                                             label={'Permit'}
                                                             startDate={this.state.form.fileData.permitStart ?? undefined}
                                                             expiryDate={this.state.form.fileData.permitEnd}
                                              />
                                          );
                                      }}
                                  </MFormControl>
                              </div>
                              {tmPlanRequiredStates.some(item => this.state.form.notice.detail!.tmType.includes(item)) ? <div className="col-12 md:col-2">
                                  <MFormControl label={''} id="detail.tmPlanStatus">
                                      {() => {
                                          return (
                                              <StatusControl size={40}
                                                             initialValue={this.state.form.fileData.tmPlanState}
                                                             onClick={this.onFileUploadClicked.bind(this, 12)}
                                                             label={'TM Plan'}
                                                             startDate={this.state.form.fileData.tmPlanStart ?? undefined}
                                                             expiryDate={this.state.form.fileData.tmPlanEnd}
                                              />
                                          );
                                      }}
                                  </MFormControl>
                              </div> : <div></div>}
                          </FormSection>

                          <FormSection title="Documents">
                              <div className="min-w-full">
                                  <FileListControl rowData={this.state.form.miscFiles}
                                                   updateIncludeState={this.ChangeFileIncludeStatus}
                                                   addFile={this.onFileUploadClicked.bind(this, -1)}
                                                   refresh={this.onFileListRefresh}
                                                   fileClient={this.m_fileClient}
                                                   jobComplete={false}
                                                   user={userName!}
                                                   uploadPermission={hasNoticingRole}
                                                   role={roles!}
                                  />
                              </div>
                          </FormSection>

                          <Divider/>

                          <FormSection title="Location">
                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="Start location - Eastings"
                                                     fieldName="detail.easting">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isEditDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="Start location - Northings"
                                                     fieldName="detail.northing">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isEditDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="End location - Eastings"
                                                     fieldName="detail.easting2">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isEditDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="End location - Northings"
                                                     fieldName="detail.northing2">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isEditDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>
                          </FormSection>

                          <Divider/>

                          <FormSection title="Address">
                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Address1"
                                                     fieldName="detail.address1">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={50}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isEditDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Address2"
                                                     fieldName="detail.address2">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={50}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isEditDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Address3"
                                                     fieldName="detail.address3">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={50}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isEditDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>
                          </FormSection>
                          
                          <Divider/>
                          <FormSection title="Registrations">
                              <div className="min-w-full">
                                  <RegistrationListControl
                                      noticeId={id}
                                      rowData={this.state.form.registrations}
                                      history={this.props.history}
                                      navigate={this.props.navigate}
                                      match={this.props.match}
                                      location={this.props.location}
                                  />
                              </div>
                          </FormSection>

                          <Divider/>
                          <MFormSection title="History">

                              <div className="min-w-full">
                                  <AuditListControl rowData={this.state.form.audit}/>
                              </div>
                          </MFormSection>

                      </div>
                  </div>
              </MForm>

          </MPage>
        );
    }
}

export default withMsal(WithRouter(EditNoticeDetailPage));